export const TOKEN_STORAGE = 'homepal_admin_token_storage'
export const ONE_BUTTON = 'one_button'
export const TWO_BUTTONS = 'two_buttons'
export const THREE_BUTTONS = 'three_buttons'

export const USERS_PAGE = 'users_page'
export const LAUNDRY_TIMES_PAGE = 'laundry_times_page'
export const INFO_SETTINGS_PAGE = 'info_settings_page'
export const LAUNDRY_BOOKINGS_PAGE = 'laundry_bookings_page'
export const BOOKING_SYSTEM_PAGE = 'booking_system_page'
export const NEWS_FEED_PAGE = 'news_feed_page'
export const PAST_BOOKINGS_PAGE = 'past_bookings_page'
export const SETTINGS_PAGE = 'settings_page'

export const LAUNDRY_ROOM = 'S'
export const LAUNDRY_MACHINE = 'M'

export const PHONE = 'phone'
export const EMAIL = 'email'
export const URL = 'url'
export const TEXT = 'text'

export const INTRO_SHOWN = 'intro_shown'

export const ALL_DAYS = 'mo;tu;we;th;fr;sa;su'
export const WEEKDAYS = 'mo;tu;we;th;fr'
export const WEEKEND = 'sa;su'
export const WEEKDAYS_ARRAY = ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su']



// WEBPACK FOOTER //
// ./src/helpers/Constants/index.js